/**
 * @generated SignedSource<<85eacef6fd989895db3be25748b3bb17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OnboardingAnswerFieldInputObject = {
  key: string;
  value: string;
};
export type onboardingPage_LeadAnswerSaveMutation$variables = {
  fields?: ReadonlyArray<OnboardingAnswerFieldInputObject> | null | undefined;
  nextStepKey?: string | null | undefined;
  stepKey: string;
  token?: string | null | undefined;
  values?: ReadonlyArray<string> | null | undefined;
};
export type onboardingPage_LeadAnswerSaveMutation$data = {
  readonly leadAnswerSave: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly lead: {
      readonly completenessScore: number;
    } | null | undefined;
  } | null | undefined;
};
export type onboardingPage_LeadAnswerSaveMutation = {
  response: onboardingPage_LeadAnswerSaveMutation$data;
  variables: onboardingPage_LeadAnswerSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fields"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nextStepKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stepKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "values"
},
v5 = [
  {
    "kind": "Variable",
    "name": "fields",
    "variableName": "fields"
  },
  {
    "kind": "Variable",
    "name": "nextStepKey",
    "variableName": "nextStepKey"
  },
  {
    "kind": "Variable",
    "name": "stepKey",
    "variableName": "stepKey"
  },
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  },
  {
    "kind": "Variable",
    "name": "values",
    "variableName": "values"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completenessScore",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "onboardingPage_LeadAnswerSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "LeadAnswerSaveMutationPayload",
        "kind": "LinkedField",
        "name": "leadAnswerSave",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "onboardingPage_LeadAnswerSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "LeadAnswerSaveMutationPayload",
        "kind": "LinkedField",
        "name": "leadAnswerSave",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d33fb596576033cd96ed85afd9eb0b0c",
    "id": null,
    "metadata": {},
    "name": "onboardingPage_LeadAnswerSaveMutation",
    "operationKind": "mutation",
    "text": "mutation onboardingPage_LeadAnswerSaveMutation(\n  $token: String\n  $stepKey: String!\n  $values: [String!]\n  $fields: [OnboardingAnswerFieldInputObject!]\n  $nextStepKey: String\n) {\n  leadAnswerSave(token: $token, stepKey: $stepKey, values: $values, fields: $fields, nextStepKey: $nextStepKey) {\n    lead {\n      completenessScore\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8a98f2c6ebebf17624e107607c3b127";

export default node;
